import {
  SHOWCASE_LOADING,
  SHOWCASE_LOADED,
  SHOWCASE_CREATED,
  SHOWCASE_EDITED,
  SHOWCASE_DELETED,
  SHOWCASE_PROCESS_LOADING,
  SHOWCASE_PROCESS_FAILED,
  SHOWCASE_DETAILS_LOADED,
  GET_DPSTATISTICS_LOADED,
  GET_SHOWCASE_CARDS,
  SHOWCASE_POST_LOADING,
  SHOWCASE_POST_LOADED,
  SHOWCASE_POST_DELETED,
  SHOWCASE_POST_PROCESS_LOADING,
  SHOWCASE_POST_PROCESS_FAILED,
  SHOWCASE_ACCESS_UPDATED,
  MY_POST_LOADED,
  MY_POST_PROCESS_FAILED,
  ADD_SHOWCASE_POST_PROCESS_LOADING,
  SHOWCASE_POST_ADDED,
  ADD_SHOWCASE_POST_PROCESS_FAILED,
  LIKE_SHOWCASE_POST,
} from "../actions/showcase";

const initialState = {
  isLoading: false,
  showcases: [],
  locations: [],
  values: [],
  myPosts: [],
  competency: false,
  dpStatistics: {
    public_showcase_count: "0",
    total_shared_count: "0",
    outstanding_DP_task_count: "0",
  },
  // countPost: [],
  errors: null,
  new: {
    isLoading: false,
    isSuccess: false,
    errors: null,
  },
  currentSelected: 0,
};

const showcaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOWCASE_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case SHOWCASE_LOADED:
      return {
        ...state,
        isLoading: false,
        showcases: action.payload.showcases,
        about: action.payload.about,
        status: action.payload.status,
        errors: null,
      };
    case SHOWCASE_CREATED:
      return {
        ...state,
        new: {
          isLoading: false,
          isSuccess: true,
          errors: null,
        },
      };
    case SHOWCASE_EDITED:
      return {
        ...state,
        new: {
          isLoading: false,
          isSuccess: true,
          errors: null,
        },
      };
    case SHOWCASE_DELETED:
      return {
        ...state,
        new: {
          isLoading: false,
          isSuccess: true,
          errors: null,
        },
      };
    case SHOWCASE_PROCESS_LOADING:
      return {
        ...state,
        new: {
          isLoading: true,
          isSuccess: false,
          errors: null,
        },
      };
    case SHOWCASE_PROCESS_FAILED:
      return {
        ...state,
        new: {
          isLoading: false,
          isSuccess: false,
          errors: action.errors,
        },
      };
    case SHOWCASE_DETAILS_LOADED:
      return {
        ...state,
        locations: action.payload.locations,
        values: action.payload.values,
        competency: action.payload.competency_status,
      };
    case GET_DPSTATISTICS_LOADED:
      return {
        ...state,
        dpStatistics: action.payload,
      };
    case GET_SHOWCASE_CARDS:
      return {
        ...state,
        showcaseCards: action.payload,
      };
    case SHOWCASE_POST_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case SHOWCASE_POST_LOADED:
      return {
        ...state,
        isLoading: false,
        errors: null,
      };
    case SHOWCASE_POST_PROCESS_LOADING:
      return {
        ...state,
        new: {
          isLoading: true,
          isSuccess: false,
          errors: null,
        },
      };
    case SHOWCASE_POST_PROCESS_FAILED:
      return {
        ...state,
        new: {
          isLoading: false,
          isSuccess: false,
          errors: action.errors,
        },
      };
    case SHOWCASE_ACCESS_UPDATED:
      return {
        ...state,
        new: {
          isLoading: false,
          isSuccess: true,
          errors: null,
        },
      };
    case SHOWCASE_POST_DELETED:
      return {
        ...state,
        new: {
          isLoading: false,
          isSuccess: true,
          errors: null,
        },
      };
    case LIKE_SHOWCASE_POST:
      return {
        ...state,
      };
    case MY_POST_LOADED:
      return {
        ...state,
        isLoading: false,
        myPosts: action.data.myPosts,
        errors: null,
      };
    case MY_POST_PROCESS_FAILED:
      return {
        ...state,
        new: {
          isLoading: false,
          isSuccess: false,
          errors: action.errors,
        },
      };
    case ADD_SHOWCASE_POST_PROCESS_LOADING:
      return {
        ...state,
        new: {
          isLoading: true,
          isSuccess: false,
          errors: null,
        },
      };
    case SHOWCASE_POST_ADDED:
      return {
        ...state,
        new: {
          isLoading: false,
          isSuccess: true,
          errors: null,
        },
      };
    case ADD_SHOWCASE_POST_PROCESS_FAILED:
      return {
        ...state,
        new: {
          isLoading: false,
          isSuccess: false,
          errors: action.errors,
        },
      };
    case "currentSelectedPublic":
      return {
        ...state,
        currentSelected: action.payload,
      };
    default:
      return state;
  }
};

export default showcaseReducer;
